import { createAsyncThunk } from '@reduxjs/toolkit';
import { EntryReviewEscalationRequestType } from 'src/ts/interfaces';

import api, { ReportPlatformFeedbackRequest } from './api';
import { NAME, REQUEST_REVIEW_ENTRY_IDENTIIFIER } from './constants';

export const getPendingReviewEntryThunk = createAsyncThunk(
  `${NAME}/getPendingReviewEntry`,
  async () => {
    const response = await api.getPendingReviewEntry();
    // Return both the entry data and queue status for page refresh state restoration
    return { entry: response.data, inQueue: (response as { in_queue?: boolean }).in_queue };
  }
);

export const requestReviewEntryThunk = createAsyncThunk(`${NAME}/requestReviewEntry`, async () => {
  try {
    const response = await api.assignEntryRequest();
    return response.data;
  } catch (error) {
    console.error(REQUEST_REVIEW_ENTRY_IDENTIIFIER, error);
    throw new Error('Failed to request entry for review');
  }
});

export const cancelReviewEntryRequestThunk = createAsyncThunk(
  `${NAME}/cancelReviewEntryRequest`,
  async () => {
    try {
      const response = await api.cancelEntryRequest();
      return response.data;
    } catch (error) {
      console.error(`${NAME}/cancelReviewEntryRequest`, error);
      throw new Error('Failed to cancel entry for review request');
    }
  }
);

export const escalateThunk = createAsyncThunk(
  `${NAME}/escalateThunk`,
  async ({ entryId, data }: { entryId: string; data: EntryReviewEscalationRequestType }) => {
    try {
      return api.escalate(entryId, data);
    } catch (error) {
      console.error(`${NAME}/escalateThunk`, error);
      throw new Error('Failed to escalate the Entry');
    }
  }
);

export const reportPlatformFeedbackThunk = createAsyncThunk(
  `${NAME}/reportPlatformFeedbackThunk`,
  async (data: ReportPlatformFeedbackRequest) => {
    try {
      return await api.reportPlatformFeedback(data);
    } catch (error) {
      console.error(`${NAME}/reportPlatformFeedbackThunk`, error);
      throw new Error('Failed to report platform feedback');
    }
  }
);

export const getSpecialtyQueuePendingCountThunk = createAsyncThunk(
  `${NAME}/getSpecialtyQueuePendingCount`,
  async () => {
    try {
      const response = await api.getSpecialtyQueuePendingCount();
      const pendingCount = response.data?.pending_count;

      if (typeof pendingCount !== 'number') {
        throw new Error('Unexpected specialty queue pending count response');
      }

      return pendingCount;
    } catch (error) {
      console.error(`${NAME}/getSpecialtyQueuePendingCount`, error);
      throw error;
    }
  }
);

export const getSocketTokenThunk = createAsyncThunk(`${NAME}/getSocketToken`, async () => {
  try {
    const response = await api.getSocketToken();
    return response.data;
  } catch (error) {
    console.error(`${NAME}/getSocketToken`, error);
    throw new Error('Failed to get socket token');
  }
});
